import React from 'react';
import Carousel from 'react-bootstrap/Carousel';

const Display = () => {
  return(
    <Carousel slide={false}>
      <Carousel.Item>
        <img
          className="local d-block"
          src="./img/communications/breath_local.jpg"
          alt="Local display shows a warning when irregularity in breathing is detected."
        />
        <Carousel.Caption>
          <h3>Respiratory Irregularity Warning</h3>
          <p>
            Local OLED displays a warning when irregularity in breathing is detected.
          </p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="local d-block"
          src="./img/communications/heart_local.jpg"
          alt="Local display shows a warning when irregularity in heart rate is detected."
        />
        <Carousel.Caption>
          <h3>Abnormal Heart Rate Warning</h3>
          <p>Local OLED displays a warning when irregularity in heart rate is detected.</p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="local d-block"
          src="./img/communications/activity_local.jpg"
          alt="Local displays shows a warning when abnormality in the infant's activity detected."
        />
        <Carousel.Caption>
          <h3>Abnormal Activity Warning</h3>
          <p>Local OLED displays a warning when abnormality in the infant's activity (too many activities) is detected.</p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="local d-block"
          src="./img/communications/environment_local.jpg"
          alt="Local displays shows the current ambient enviromental data."
        />
        <Carousel.Caption>
          <h3>Ambient Enviromental Data</h3>
          <p>Local OLED displays current ambient environmental data including temperature, humidity, and light level.</p>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  );
}

export default Display;
